import { useQuery } from "@tanstack/react-query"
import { getAllCompanies } from "@/lib/api/company.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetCompanies(enabled: boolean = true) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["all-companies"],
    queryFn: () => getAllCompanies(accessToken ?? undefined),
    enabled: enabled,
    staleTime:0,
  })
}